import React, { FC } from 'react';

// provider
import EditAssetProvider from 'pages/MerchantPages/Assets/containers/EditAsset/sharedState/EditAssetProvider';

// containers
import MassiveEditAsset from 'pages/MerchantPages/Assets/containers/EditAsset/MassiveEditAsset';

const EditAsset: FC = () => {
  return (
    <EditAssetProvider>
      <MassiveEditAsset />
    </EditAssetProvider>
  );
};

export default EditAsset;
